export const dateTypes = {
  LAST_30_MINUTES: 'LAST_30_MINUTES',
  LAST_2_HOURS: 'LAST_2_HOURS',
  LAST_6_HOURS: 'LAST_6_HOURS',
  LAST_24_HOURS: 'LAST_24_HOURS',
}
